import Spinner from "Components/Spinner";
import { useSelector, useDispatch } from "react-redux";
import { State } from "store/reducers";
import ls from "Localization";

import _ from "lodash";

import { Helmet } from "react-helmet-async";

import actions from "store/actions";

import { UserState } from "store/reducers/user";
import IUser from "Types/User";
import dayjs from "dayjs";
import Report from "Components/Report";
import { dateSort } from "Components/Report/helpers";
import { useNavigate } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import { Fab } from "@mui/material";
import useStyles from "./styles";

const columns = [
	{
		Header: ls.creationDate,
		id: "createdAt",
		accessor: (c: IUser) =>
			dayjs(c.createdAt).format(ls.dateFormatWithoutSeconds),
		show: true,
		sortMethod: dateSort,
		width: 150
	},
	{
		Header: ls.name,
		id: "name",
		show: true,
		accessor: (c: IUser) => `${c.name} ${c.lastname}`
	},
	{
		Header: ls.phoneNumber,
		id: "phoneNumber",
		show: true,
		accessor: (c: IUser) => c.phoneNumber || ls.notDefined,
		width: 150
	},
	{
		Header: ls.email,
		id: "email",
		show: true,
		accessor: (c: IUser) => c.email,
		width: 250
	},
	{
		Header: ls.birthDate,
		id: "birthDate",
		accessor: (c: IUser) => dayjs(c.birthDate).format(ls.dateFormatShort),
		show: true,
		sortMethod: dateSort,
		width: 120
	},
	{
		Header: ls.cpf,
		id: "cpf",
		show: true,
		accessor: (c: IUser) => c.cpf,
		width: 140
	}
];

let getUsersDebounded: (() => any) & _.Cancelable = _.debounce(() => {}, 250);

interface TableState {
    page: number;
    pageSize: number;
    sorted: any[];
    filtered: any[];
    toExport: boolean;
    callback: any;
}

function CreateMei() {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const classes = useStyles({});
	const state = useSelector<State, UserState>(s => s.user);

	const handleFetchData = (tableState: TableState, instance: any) => {
		const { page, pageSize, sorted, filtered, toExport, callback } = tableState;

		if (getUsersDebounded) {
			getUsersDebounded.cancel();
		}

		if (!tableState.sorted) {
			tableState.sorted = [];
		}

		tableState.filtered = filtered.filter((c: any) => c.id !== "status");

		filtered.push({
			id: "status",
			value: 2
		});

		getUsersDebounded = _.debounce(
			() =>
				dispatch(
					actions.user.getUsers(
						page * pageSize,
						pageSize,
						filtered.reduce(
							(p: any, c: any) => p + `&filters[${c.id}]=${c.value}`,
							""
						),
						sorted[0]?.id,
						sorted[0]?.desc,
						toExport,
						callback
					)
				),
			500
		);

		getUsersDebounded();
	};

	return (
		<div>
			<Helmet>
				<title>
					{ls.createMei} | {ls.appName}
				</title>
			</Helmet>
			<Report
				manual
				onFetchData={handleFetchData}
				titleText={ls.createMei}
				title={
					<span
						style={{
							alignItems: "center",
							display: "flex"
						}}
					>
						{ls.createMei}
						{state.loading ? (
							<Spinner style={{ height: 15, width: 15, margin: 5 }} />
						) : null}
					</span>
				}
				data={state.items}
				pages={state.pages}
				columns={columns}
				defaultFiltered={state.filter}
				loading={state.loading}
				visibleColumns={columns.filter(c => c.show).map(c => c.Header)}
				defaultSorted={[
					{
						id: "createdAt",
						desc: true
					}
				]}
				getTdProps={() => {
					return {
						style: {
							display: "flex",
							alignItems: "center"
						}
					};
				}}
				filterable
				onRowClicked={data => navigate(`/Dashboard/User/${data._id}`)}
			/>

			<Fab
				color="primary"
				aria-label="Add"
				style={{ position: 'fixed', bottom: '16px', right: '16px',  zIndex: 1000}}
				onClick={() => navigate("/Dashboard/User/Create")}
			>
				<MdAdd size={24} />
			</Fab>
		</div>
	);
}

export default CreateMei;
